import Text from '../../common/component/Text';
import {ISettingItemTextType} from '../type';

export default function SettingItemTextV4({
  text,
  type = 'main',
}: {
  text: string;
  type?: ISettingItemTextType;
}) {
  return (
    <Text
      className={cn('leading-[1.25] mt-4 first:!mt-0', {
        's16-medium-white light:text-black': type === 'main',
        's12-medium-grey06': type === 'sub',
        's13-semibold-white light:text-black': type === 'content',
      })}
    >
      {text}
    </Text>
  );
}
